
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0H23.9874V15.9982H0V0Z","fill":"white"}}),_c('path',{attrs:{"d":"M10.7942 9.59403V15.9982H13.1933V9.59403H23.9875V6.39573H13.1933V0H10.7942V6.39573H0V9.59403H10.7942Z","fill":"#CF142B"}}),_c('path',{attrs:{"d":"M13.9951 5.17856V0H21.7615L13.9951 5.17856ZM13.9951 10.8195V15.9982H21.7615L13.9951 10.8195ZM9.99611 10.8195V15.9982H2.22979L9.99611 10.8195ZM9.99611 5.17856V0H2.22979L9.99611 5.17856ZM0.00195312 1.48715V5.33259H5.76891L0.00195312 1.48715ZM23.9893 1.48715V5.33259H18.2224L23.9893 1.48715ZM23.9893 14.511V10.6656H18.2224L23.9893 14.511ZM0.00195312 14.511V10.6656H5.76891L0.00195312 14.511Z","fill":"#00247D"}}),_c('path',{attrs:{"d":"M23.9874 0H22.6551L14.672 5.33259H16.0043L24 0H23.9874ZM9.31544 10.6653H7.98312L0 15.9979H1.33232L9.328 10.6653H9.31544ZM6.66144 5.33675H7.99368L0 0V0.8944L6.66144 5.33675ZM17.3218 10.6633H15.9895L23.9832 16V15.1056L17.3218 10.6633Z","fill":"#CF142B"}})])
          )
        }
      }
    